(function() {
  if (window.__joyeeAnnouncementInit) return;
  window.__joyeeAnnouncementInit = true;

  /* ------------------------------------------------------------------------
     Countdown helpers
     ------------------------------------------------------------------------ */
  function parseLabels(str) {
    var parts = (str || 'd,h,m,s').split(',');
    return {
      d: parts[0] || 'd',
      h: parts[1] || 'h',
      m: parts[2] || 'm',
      s: parts[3] || 's'
    };
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function computeExpiry(root) {
    var mode = root.getAttribute('data-timer-mode');
    if (mode === 'off' || !mode) return null;

    if (mode === 'target') {
      var dtStr = root.getAttribute('data-timer-target');
      if (!dtStr) return null;
      var normalized = dtStr.trim().replace(' ', 'T');
      if (/T\d{2}:\d{2}$/.test(normalized)) normalized += ':00';
      var t = new Date(normalized).getTime();
      return isNaN(t) ? null : t;
    }

    if (mode === 'daily') {
      var hhmm = root.getAttribute('data-timer-daily') || '00:00';
      var now = new Date();
      var parts = hhmm.split(':');
      var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(),
                            parseInt(parts[0], 10) || 0,
                            parseInt(parts[1], 10) || 0, 0, 0);
      if (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + 1);
      }
      return target.getTime();
    }
    return null;
  }

  function formatCountdown(diffMs, showDays, labels) {
    if (diffMs <= 0) return null;
    var totalSec = Math.floor(diffMs / 1000);
    var d = Math.floor(totalSec / 86400);
    var h = Math.floor((totalSec % 86400) / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    if (showDays) {
      return d + labels.d + ' ' + pad(h) + labels.h + ' ' + pad(m) + labels.m + ' ' + pad(s) + labels.s;
    }
    var totalH = d * 24 + h;
    return pad(totalH) + labels.h + ' ' + pad(m) + labels.m + ' ' + pad(s) + labels.s;
  }

  /* ------------------------------------------------------------------------
     Single bar instance
     ------------------------------------------------------------------------ */
  function initBar(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-joyee-announcement-slide]'));
    if (slides.length === 0) return;

    var prevBtn   = root.querySelector('[data-joyee-announcement-prev]');
    var nextBtn   = root.querySelector('[data-joyee-announcement-next]');
    var toggleBtn = root.querySelector('[data-joyee-announcement-toggle]');

    var autoplay     = root.getAttribute('data-autoplay') === 'true';
    var autoplayMs   = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 5000;
    var timerMode    = root.getAttribute('data-timer-mode') || 'off';
    var showDays     = root.getAttribute('data-timer-show-days') === 'true';
    var labels       = parseLabels(root.getAttribute('data-timer-labels'));
    var expiredText  = root.getAttribute('data-timer-expired-text') || '';

    var current  = 0;
    var playing  = autoplay;
    var rotateIv = null;
    var tickIv   = null;

    /* ---- Inject [timer] placeholder spans ---- */
    function injectTimerSpans() {
      if (timerMode === 'off') return;
      slides.forEach(function(slide) {
        var textEl = slide.querySelector('[data-joyee-announcement-text]');
        if (!textEl || textEl.innerHTML.indexOf('[timer]') === -1) return;
        var styleAttr = slide.getAttribute('data-timer-style');
        var span = '<span class="joyee-announcement__timer"' +
                   (styleAttr ? ' style="' + styleAttr + '"' : '') + '>…</span>';
        textEl.innerHTML = textEl.innerHTML.split('[timer]').join(span);
      });
    }

    /* ---- Slide rendering ---- */
    function renderSlide(i) {
      slides.forEach(function(s, idx) {
        s.classList.toggle('joyee-announcement__slide--active', idx === i);
      });
      // If any slide has a custom background, apply it to the section root so
      // it fills the full bar width (not just the center viewport).
      var active = slides[i];
      if (active) {
        var bg = active.style.background || active.style.backgroundColor;
        if (bg) {
          root.style.background = bg;
        } else {
          root.style.background = '';  // revert to section default
        }
      }
    }
    function go(i) {
      if (slides.length === 0) return;
      current = (i + slides.length) % slides.length;
      renderSlide(current);
    }
    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    /* ---- Autoplay ---- */
    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      rotateIv = setInterval(next, autoplayMs);
    }
    function stopAutoplay() {
      if (rotateIv) { clearInterval(rotateIv); rotateIv = null; }
    }
    function setPlaying(p) {
      playing = p;
      if (toggleBtn) {
        // The label says what a press will do; no aria-pressed, which read as "Pause, pressed" while playing.
        toggleBtn.setAttribute('data-playing', p ? 'true' : 'false');
        toggleBtn.setAttribute('aria-label', toggleBtn.getAttribute(p ? 'data-label-pause' : 'data-label-play'));
      }
      if (p) startAutoplay(); else stopAutoplay();
    }

    /* ---- Countdown ticker ---- */
    function tick() {
      if (timerMode === 'off') return;
      var expiry = computeExpiry(root);
      if (expiry === null) return;
      var diff = expiry - Date.now();
      var formatted = formatCountdown(diff, showDays, labels);
      var isExpired = formatted === null;

      root.querySelectorAll('.joyee-announcement__timer').forEach(function(el) {
        el.textContent = isExpired ? expiredText : formatted;
      });

      if (isExpired && timerMode === 'target') {
        var activeSlide = slides[current];
        if (activeSlide && activeSlide.getAttribute('data-expire-action') === 'hide') {
          var nextIdx = (current + 1) % slides.length;
          var tries = 0;
          while (tries < slides.length &&
                 slides[nextIdx].getAttribute('data-expire-action') === 'hide') {
            nextIdx = (nextIdx + 1) % slides.length;
            tries++;
          }
          if (tries >= slides.length) {
            root.style.display = 'none';
            stopAutoplay();
            if (tickIv) { clearInterval(tickIv); tickIv = null; }
            return;
          }
          go(nextIdx);
        }
      }
    }

    /* ---- Wire controls ---- */
    if (prevBtn) prevBtn.addEventListener('click', function() {
      prev();
      if (playing) startAutoplay();
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      next();
      if (playing) startAutoplay();
    });
    if (toggleBtn) toggleBtn.addEventListener('click', function() {
      setPlaying(!playing);
    });

    root.addEventListener('mouseenter', function() { if (playing) stopAutoplay(); });
    root.addEventListener('mouseleave', function() { if (playing) startAutoplay(); });
    root.addEventListener('focusin',    function() { if (playing) stopAutoplay(); });
    root.addEventListener('focusout',   function() { if (playing) startAutoplay(); });

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) stopAutoplay();
      else if (playing) startAutoplay();
    });

    /* ---- Init ---- */
    injectTimerSpans();
    renderSlide(current);
    if (autoplay) startAutoplay();
    if (timerMode !== 'off') {
      tick();
      tickIv = setInterval(tick, 1000);
    }

    /* Expose a destroy hook so shopify:section:unload can clean up intervals
       (prevents leaked timers when merchant removes the section in the editor). */
    root.__joyeeDestroy = function() {
      stopAutoplay();
      if (tickIv) { clearInterval(tickIv); tickIv = null; }
    };
  }

  function initAll() {
    document.querySelectorAll('[data-joyee-announcement]').forEach(function(root) {
      if (root.__joyeeInit) return;
      root.__joyeeInit = true;
      initBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', function(e) {
      var root = e.target.querySelector('[data-joyee-announcement]');
      if (root && typeof root.__joyeeDestroy === 'function') root.__joyeeDestroy();
    });
  }
})();
